module.exports = __webpack_public_path__ + "media/6_2.e09238b4.wav";